import { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Section, SectionInner } from '../../components/Shared/Section';
import { FormattedMessage, injectIntl } from 'react-intl';
import { toastr } from 'react-redux-toastr';
import * as instrumentActions from '../../redux/actions/instrumentActions';
import * as firmwareActions from '../../redux/actions/firmwareActions';
import * as accountActions from '../../redux/actions/accountActions';
import * as generalActions from '../../redux/actions/generalActions';
import cn from 'classnames';
import styles from './Devices.module.scss';
import { H2, H3, H4 } from '../../components/Shared/Headings';
import { Table, TableHead, TableBody, TH, TR, TD } from '../../components/Shared/Table';
import { Button, LargeButton } from '../../components/Shared/Buttons';
import Spinner from '../../components/Shared/Loaders/Spinner';
import Dropdown from '../../components/Shared/Dropdown/Dropdown';
import Modal from '../../components/Shared/Modal/Modal';
import ChangeDeviceName from '../../pages/DevicesPage/ChangeDeviceName';
import { toastrOptions } from '../../constants/toastrOptions';

const windowsIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="74.611"
    height="74.841"
    viewBox="0 0 74.611 74.841"
  >
    <path
      id="path13"
      d="M0,10.6,30.491,6.444,30.5,35.854.028,36.028ZM30.477,39.243,30.5,68.68.024,64.49l0-25.444ZM34.173,5.9,74.6,0V35.481L34.173,35.8ZM74.611,39.52,74.6,74.841,34.173,69.135l-.057-29.681Z"
      fill="#793170"
    />
  </svg>
);

const macIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="60.626"
    height="71.975"
    viewBox="0 0 60.626 71.975"
  >
    <path
      id="path4"
      d="M59.355,56.091a39.131,39.131,0,0,1-3.87,6.957A35.348,35.348,0,0,1,50.5,69.072a9.67,9.67,0,0,1-6.406,2.821,16.057,16.057,0,0,1-5.918-1.413,16.98,16.98,0,0,0-6.371-1.408,17.556,17.556,0,0,0-6.551,1.408,17.627,17.627,0,0,1-5.661,1.488q-3.285.14-6.551-2.9a37.117,37.117,0,0,1-5.214-6.238A43.139,43.139,0,0,1,2.315,51.883,40.1,40.1,0,0,1,0,38.831a23.835,23.835,0,0,1,3.13-12.47,18.361,18.361,0,0,1,6.555-6.631,17.634,17.634,0,0,1,8.862-2.5,20.867,20.867,0,0,1,6.855,1.6,22.036,22.036,0,0,0,5.437,1.6,32.534,32.534,0,0,0,6.029-1.883,19.928,19.928,0,0,1,8.195-1.455q9.083.733,13.63,7.176-8.124,4.922-8.041,13.773a15.194,15.194,0,0,0,4.989,11.449,16.4,16.4,0,0,0,4.985,3.27q-.6,1.739-1.271,3.337ZM45.467,1.44a15.354,15.354,0,0,1-3.936,10.071c-3.163,3.7-6.989,5.835-11.138,5.5a11.206,11.206,0,0,1-.084-1.364A15.776,15.776,0,0,1,34.485,5.468a16.077,16.077,0,0,1,5.087-3.819A15.168,15.168,0,0,1,45.392,0a13.073,13.073,0,0,1,.076,1.44Z"
      transform="translate(0 -0.001)"
      fill="#793170"
    />
  </svg>
);

const IDxIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="126.519"
    height="60.389"
    viewBox="0 0 126.519 60.389"
  >
    <path
      id="Subtraction_27"
      data-name="Subtraction 27"
      d="M40.128,61.4a10.46,10.46,0,0,1-2.873-.36c-2.431-.7-9.134-2.914-9.635-3.369a2.827,2.827,0,0,1,.8-2.763c.967.158,4.259.957,6.905,1.6h.006c1.5.364,2.8.679,3.413.814a8.835,8.835,0,0,0,1.836.156,18.97,18.97,0,0,0,4.666-.571c.239-.072,23.909-7.251,24.148-7.383.093-.052.241-.152.413-.267.25-.169.561-.378.809-.509.1-.03.208-.07.35-.119a23.71,23.71,0,0,1,2.332-.7.957.957,0,0,1,.232-.029,1.542,1.542,0,0,1,1.2.843c.335-.164.672-.336,1-.513.289-.151.583-.318.965-.538a49.786,49.786,0,0,0-4.912-3.739,1.462,1.462,0,0,1-.436.068,1.272,1.272,0,0,1-.384-.059l-3.65-.607c-11.693,2.213-19.658,3.634-23.671,4.225-.9.134-1.743.236-2.521.3a11.414,11.414,0,0,1-3.638.485c-2.26,0-4.163-.435-4.332-.99H33.14v-.813c-.171-.113-.332-.225-.468-.319a9.711,9.711,0,0,0-1.4-.854,2.667,2.667,0,0,1-.258-.142l-.005,0a54.544,54.544,0,0,1-7-5.954c-2.469-2.348-5.458-5.34-8.418-8.426l-.34.538c-.806,1.274-2.305,3.643-2.954,4.7a1.4,1.4,0,0,1-1.183.757,1.328,1.328,0,0,1-1.067-.563A1.058,1.058,0,0,1,9.9,35.3c.155-.409.438-1.367.738-2.381.559-1.89,1.254-4.242,1.775-5.421-1.349-1.456-2.277-2.5-2.481-2.791l-.425-.6c-4.086-5.8-6.812-9.8-8.1-11.894.143.119.306.248.488.38.509.372,1.79,1.316,3.562,2.622l.013.01,2.01,1.482.406.3c7.426,5.473,19.855,14.633,22.906,16.825A16.78,16.78,0,0,0,40.5,36.6a22.808,22.808,0,0,0,3.149-.217c1.052-.149,10.3-1.643,12.138-1.94,13.225-2.135,35.16-5.7,38.085-6.218a6.286,6.286,0,0,0,1.772-.552c-1.669,2.6-3.271,5.029-4.76,7.218a13.015,13.015,0,0,1-8.765,5.63c-.273.047-1.76.333-3.831.731l-.013,0c-1.723.332-3.348.644-4.967.953a2.85,2.85,0,0,1-.112.333,2.8,2.8,0,0,1-.139.291,46.591,46.591,0,0,1,5.139,4,32.1,32.1,0,0,1,6.079-2.571,54.238,54.238,0,0,1,10.8-2.035c3.532-.34,7.009-.513,10.334-.513a60.74,60.74,0,0,1,15.317,1.643c4.027,1.1,6.358,2.648,6.742,4.488a2.854,2.854,0,0,1,.06.511v.15c-.067,2.481-3.476,4.8-10.134,6.887a48.5,48.5,0,0,1-14.5,2.281,43.338,43.338,0,0,1-14.111-2.322,34.381,34.381,0,0,1-6.909-3.192A14.424,14.424,0,0,1,78.458,49.5c-.148-.188-.325-.393-.541-.626l-.066.038-.008,0-.112.065L77.7,49c-.442.255-.823.475-1.185.664-.4.217-.815.426-1.221.622.1.754-.057,1.318-.442,1.545-.289.131-.524.267-.751.4a7.248,7.248,0,0,1-1.712.757c-.169.022-.415.04-.675.06a7.967,7.967,0,0,0-1.21.143c-7.211,2.187-22.419,6.759-24.569,7.339A22.971,22.971,0,0,1,40.128,61.4Zm65.493-18.071c-3.284,0-6.78.176-10.389.524-8.684.836-13.2,2.8-15.844,4.2.124.142.23.27.325.39a13.012,13.012,0,0,0,3.011,2.326,33.015,33.015,0,0,0,6.631,3.063,41.583,41.583,0,0,0,13.523,2.221,46.841,46.841,0,0,0,14.01-2.209c7.015-2.2,9.226-4.37,8.956-5.668-.251-1.205-2.3-2.406-5.619-3.3A57.223,57.223,0,0,0,105.621,43.325ZM40.5,35.525a15.7,15.7,0,0,1-9.07-2.566C28.39,30.774,15.986,21.631,8.575,16.169l-.035-.026c-2.949-2.174-5.278-3.89-6-4.416C1.382,10.876.875,10.128,1.035,9.5c.215-.836,1.621-1.429,4.18-1.762,5.946-.776,48.093-6.31,49.636-6.656a4.221,4.221,0,0,1,.912-.079A18.263,18.263,0,0,1,64.6,3.63c2.477,1.723,20.042,13.347,26.654,17.723l.007,0,2.425,1.605c1.2.8,2.423,1.985,2.23,2.906-.131.624-.881,1.06-2.23,1.3-2.68.47-23.017,3.786-38.068,6.217-7.292,1.176-11.482,1.846-12.118,1.936A21.507,21.507,0,0,1,40.5,35.525Zm22.8-9.731c-2.311,0-3.943.632-4.06,1.572a1.113,1.113,0,0,0,.278.824c.718.918,2.62,1.685,4.847,1.954a13.3,13.3,0,0,0,1.594.1c2.31,0,3.942-.632,4.06-1.572a1.112,1.112,0,0,0-.277-.823c-.717-.918-2.62-1.686-4.847-1.956A13.637,13.637,0,0,0,63.3,25.794Z"
      transform="translate(-1.006 -1.007)"
      fill="#793170"
    />
  </svg>
);

const beaconIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="79.328"
    height="65.461"
    viewBox="0 0 79.328 65.461"
  >
    <path
      id="Path_1299"
      data-name="Path 1299"
      d="M79.2,1.214a1,1,0,0,1,0,.991c-.133.221-.506.864-.972,1.683v.045c-.81,1.407-1.918,3.351-2.782,4.808a18.715,18.715,0,0,1-3.66,4.406l-.074.068c-.407.368-14.95,12.419-30.509,25.28-7.045,5.823-30.145,24.9-31.421,25.832A4.924,4.924,0,0,1,7,65.46a2.159,2.159,0,0,1-1.251-.382c-.04-.03-3.906-2.749-4.578-3.327a2.839,2.839,0,0,1-.947-1.526,11.991,11.991,0,0,1,0-4.578,8.634,8.634,0,0,1,3.817-6.31,10,10,0,0,0,.8-.657c.648-.608,9.48-6.762,18.826-13.292,9.117-6.363,18.537-12.948,19.6-13.831a7.173,7.173,0,0,1,2.645-1.428,9.019,9.019,0,0,1,2.536-.3c.27,0,.555,0,.918.019H49.6a8.431,8.431,0,0,0,4.116-1.261c.741-.475,13.419-8.164,13.552-8.238a7.052,7.052,0,0,0,1.928-1.624c.142-.157.27-.3.423-.461.608-.613,5.563-6.913,6.1-7.683A1.4,1.4,0,0,1,76.935,0a3.117,3.117,0,0,1,1.384.373,2.106,2.106,0,0,1,.878.839m-52.8,42.917-4.744-3.267-3.675,2.821,4.74,3.356Zm5-4.239-4.573-3.125-3.586,2.684,4.6,3.218Z"
      transform="translate(0 0.001)"
      fill="#793170"
    />
  </svg>
);

const devices = {
  Beacon: beaconIcon,
  IDx: IDxIcon,
  MegaISQ2: beaconIcon,
};

class Devices extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showRegisterInstrumentModal: false,
      fullModal: false,
      showDownloadFirmwareModal: false,
      showDownloadGatewayModal: false,
      downLoadingFirmwareType: null,
      showInstrumentNameModal: false,
      instrumentName: '',
      selectedInstrumentType: 'Beacon',
    };

    this.intl = props.intl;

    this.actAsOther = this.props.actAsOtherId ? true : false;

    this.showRegisterInstrumentModal = this.showRegisterInstrumentModal.bind(this);
    this.hideRegisterInstrumentModal = this.hideRegisterInstrumentModal.bind(this);
    this.showDownloadFirmwareModal = this.showDownloadFirmwareModal.bind(this);
    this.hideDownloadFirmwareModal = this.hideDownloadFirmwareModal.bind(this);
    this.showDownloadGatewayModal = this.showDownloadGatewayModal.bind(this);
    this.hideDownloadGatewayModal = this.hideDownloadGatewayModal.bind(this);
    this.shareInstrumentPatients = this.shareInstrumentPatients.bind(this);
    this.downloadFirmware = this.downloadFirmware.bind(this);
    this.getCurrentUserId = this.getCurrentUserId.bind(this);
    this.instrumentNameChanged = this.instrumentNameChanged.bind(this);
  }

  componentDidMount() {
    //Cannot act as if not SuperAdmin or AdminLv1
    if (
      this.props.user.role !== 'SuperAdmin' &&
      this.props.user.role !== 'AdminLv1' &&
      this.props.user.role !== 'AdminLv2' &&
      this.actAsOther
    ) {
      return;
    }

    this.props.actions.getInstruments(this.getCurrentUserId());
    this.gettingInstruments = true;
  }

  componentDidUpdate(prevProps) {
    if (this.props.user !== prevProps.user) {
      if (
        this.props.user.role !== 'SuperAdmin' &&
        this.props.user.role !== 'AdminLv1' &&
        this.props.user.role !== 'AdminLv2' &&
        this.actAsOther
      ) {
        return;
      }

      this.props.actions.getInstruments(this.getCurrentUserId());
      this.gettingInstruments = true;
    }
  }

  onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.setInstrumentName.complete) {
      this.closeInstrumentModal();
    }
    if (nextProps.shareInstrumentPatients.complete && this.sharingInstrumentPatients) {
      this.sharingInstrumentPatients = false;
      const message =
        this.props.shareInstrumentPatients.sharePatients === true
          ? this.intl.formatMessage({
              id: 'devices.patientShared',
              defaultMessage: 'Instrument patients shared',
            })
          : this.intl.formatMessage({
              id: 'devices.patientNotShared',
              defaultMessage: 'Instrument patients not shared',
            });
      toastr.success(
        this.intl.formatMessage({ id: 'general.success', defaultMessage: 'Success' }),
        this.intl.formatMessage({ id: message }),
        toastrOptions
      );
    }

    if (nextProps.downloadFirmware.complete && this.downloadingFirmware) {
      this.downloadingFirmware = false;
      this.setState({ downLoadingFirmwareType: null });
      toastr.success(
        this.intl.formatMessage({ id: 'general.success', defaultMessage: 'Success' }),
        this.intl.formatMessage({
          id: 'devices.firmwareDownloaded',
          defaultMessage: 'Firmware downloaded',
        }),
        toastrOptions
      );
      this.setState({
        showDownloadFirmwareModal: false,
        showDownloadGatewayModal: false,
      });
    }

    if (nextProps.getInstruments.complete && this.gettingInstruments) {
      this.gettingInstruments = false;
      const instrumentSourceUserGroupIds = nextProps.instruments
        .map((instrument) => instrument.sourceUserGroupId)
        .filter(this.onlyUnique);

      this.props.actions.subscribeToInstrumentsChange(
        instrumentSourceUserGroupIds,
        this.getCurrentUserId()
      );

      // if (nextProps.instruments.length === 0) {
      //   this.showRegisterInstrumentModal(true);
      // }
    }
  }

  componentWillUnmount() {
    const instrumentSourceUserGroupIds = this.props.instruments
      .map((instrument) => instrument.sourceUserGroupId)
      .filter(this.onlyUnique);

    this.props.actions.unsubscribeFromInstrumentsChange(instrumentSourceUserGroupIds);
  }

  getCurrentUserId() {
    return this.props.actAsOtherId ? this.props.actAsOtherId : this.props.user.id;
  }

  showRegisterInstrumentModal() {
    this.setState({
      showRegisterInstrumentModal: true,
      fullModal: this.props.instruments.length === 0,
    });
  }

  hideRegisterInstrumentModal(reloadInstruments) {
    this.setState({
      showRegisterInstrumentModal: false,
      fullModal: false,
    });

    if (reloadInstruments === true) {
      this.props.actions.getInstruments(this.getCurrentUserId());
    }
    return true;
  }

  showDownloadFirmwareModal() {
    this.setState({
      showDownloadFirmwareModal: true,
    });
  }

  hideDownloadFirmwareModal() {
    this.setState({
      showDownloadFirmwareModal: false,
    });
  }

  showDownloadGatewayModal() {
    this.setState({
      showDownloadGatewayModal: true,
    });
  }

  hideDownloadGatewayModal() {
    this.setState({
      showDownloadGatewayModal: false,
    });
  }

  shareInstrumentPatients(instrumentId, share) {
    if (this.props.user.hasInstrumentPendingUpdates) {
      const content = (
        <div>
          <p>
            {this.intl.formatMessage({
              id: 'idxMessage.inOrderToUse',
              defaultMessage:
                'In order to use this functionality you need to upgrade your IDx to the latest software.',
            })}
          </p>
          <p>
            {this.intl.formatMessage({
              id: 'idxMessage.forMoreInformation',
              defaultMessage: 'For more information on how to update your IDx please follow:',
            })}
          </p>
          <a
            href="https://www.osstell.com/wp-content/uploads/2015/03/Software-Upgrade-6.0.pdf"
            target="_blank"
            rel="noreferrer"
          >
            {this.intl.formatMessage({
              id: 'idxMessage.howToUpgrade',
              defaultMessage: 'How to upgrade',
            })}
          </a>
        </div>
      );
      this.props.actions.showAlert(
        this.intl.formatMessage({
          id: 'idxMessage.upgradeAvailable',
          defaultMessage: 'IDx Upgrade available',
        }),
        content
      );
      return;
    }

    this.sharingInstrumentPatients = true;
    this.props.actions.shareInstrumentPatients(
      this.getCurrentUserId(),
      instrumentId,
      share,
      this.actAsOther
    );
  }

  renderDeviceRows() {
    if (this.props.instruments && this.props.instruments.length > 0) {
      return this.props.instruments.map((instrument, index) => {
        const inst = {
          id: instrument.id,
          serialNumber: instrument.serialNumber,
          pukCode: instrument.puk,
          lastMeasurement: instrument.lastMeasurement,
          firmwareVersion: instrument.firmware,
          name: instrument.name ? instrument.name : instrument.serialNumber,
          shareAllPatients: instrument.shareAllPatients,
          sourceSystem: instrument.sourceSystem,
          variant: instrument.variant,
          instrumentModel: instrument.instrumentModel,
          demo: instrument.setDemo,
        };
        return (
          <TR key={index}>
            <TD className={styles.icon} contentWidth>
              <div className={styles.deviceIcon}>
                {devices[inst.instrumentModel] || devices.IDx}
              </div>
            </TD>
            <TD>{inst.name}</TD>
            <TD align="right" contentWidth>
              {this.getSharingDataString(inst)}
            </TD>
            <TD align="right" contentWidth>
              {(inst.instrumentModel === 'IDx' && inst.pukCode) || 'N/A'}
            </TD>
            <TD align="right" contentWidth>
              {inst.serialNumber || '-'}
            </TD>
            <TD align="right" contentWidth>
              {inst.firmwareVersion || '-'}
            </TD>
            <TD contentWidth button>
              <Dropdown align="right" options={this.getInstrumentOptions(inst)}>
                <div className={styles.dropdownToggle}>
                  <i></i>
                </div>
              </Dropdown>
            </TD>
          </TR>
        );
      });
    }
  }

  renderDeviceRowsOnMobile() {
    if (this.props.instruments && this.props.instruments.length > 0) {
      return this.props.instruments.map((instrument, index) => {
        const inst = {
          id: instrument.id,
          serialNumber: instrument.serialNumber,
          pukCode: instrument.puk,
          lastMeasurement: instrument.lastMeasurement,
          firmwareVersion: instrument.firmware,
          name: instrument.name ? instrument.name : instrument.serialNumber,
          shareAllPatients: instrument.shareAllPatients,
          sourceSystem: instrument.sourceSystem,
          variant: instrument.variant,
          instrumentModel: instrument.instrumentModel,
          demo: instrument.setDemo,
        };
        return (
          <div key={`${index}-mobile`} className={styles.mobileRow}>
            <div className={styles.rowInfoContainer}>
              <div className={styles.rowInMobileRow}>
                <span>
                  <b>
                    {<FormattedMessage id="devices.tableHeader.type" defaultMessage="Type" />}:{' '}
                  </b>
                  {inst.instrumentModel}
                </span>
                <span>
                  <b>
                    {<FormattedMessage id="devices.tableHeader.name" defaultMessage="Name" />}:{' '}
                  </b>
                  {inst.name}
                </span>
              </div>
              <div className={styles.rowInMobileRow}>
                <span>
                  <b>
                    {
                      <FormattedMessage
                        id="devices.tableHeader.sharingData"
                        defaultMessage="Sharing data"
                      />
                    }
                    :{' '}
                  </b>
                  {this.getSharingDataString(inst)}{' '}
                </span>
                <span>
                  <b>{<FormattedMessage id="devices.tableHeader.puk" defaultMessage="Puk" />}: </b>
                  {(inst.instrumentModel === 'IDx' && inst.pukCode) || 'N/A'}
                </span>
              </div>
              <div>
                <span>
                  <b>
                    {
                      <FormattedMessage
                        id="devices.tableHeader.serial"
                        defaultMessage="Serial number"
                      />
                    }
                    :{' '}
                  </b>
                  {inst.serialNumber || '-'}
                </span>
              </div>
              <div>
                <span>
                  <b>
                    {
                      <FormattedMessage
                        id="devices.tableHeader.firmware"
                        defaultMessage="Firmware"
                      />
                    }
                    :{' '}
                  </b>
                  {inst.firmwareVersion || '-'}
                </span>
              </div>
            </div>

            <Dropdown
              className={styles.deviceButton}
              align="right"
              options={this.getInstrumentOptions(inst)}
            >
              <div className={styles.dropdownToggle}>
                <i></i>
              </div>
            </Dropdown>
          </div>
        );
      });
    }
  }

  getInstrumentOptions(inst) {
    const options = [];
    options.push({
      label: this.intl.formatMessage({ id: 'devices.changeName', defaultMessage: 'Change name' }),
      action: () => {
        if (this.props.user.role === 'Demo') {
          this.props.actions.showAlert(
            this.intl.formatMessage({
              id: 'patientList.demoLimitation',
              defaultMessage: 'DEMO Limitation',
            }),
            this.intl.formatMessage({
              id: 'general.actionLimitedOnDemoAccount',
              defaultMessage: 'You cannot perform this action on a demo account.',
            })
          );
        } else {
          this.openInstrumentNameModal(inst);
        }
      },
    });
    inst.instrumentModel === 'IDx' &&
      options.push({
        label: this.intl.formatMessage({
          id: 'devices.toggleDataSharing',
          defaultMessage: 'Toggle data sharing',
        }),
        action: () => this.shareInstrumentPatients(inst.id, !inst.shareAllPatients),
      });
    return options;
  }
  getSharingDataString(inst) {
    if (inst.instrumentModel !== 'IDx') return 'N/A';
    return inst.shareAllPatients
      ? this.intl.formatMessage({ id: 'general.yes', defaultMessage: 'Yes' })
      : this.intl.formatMessage({ id: 'general.no', defaultMessage: 'No' });
  }
  downloadFirmware(name) {
    this.downloadingFirmware = true;

    this.setState({ downLoadingFirmwareType: name });
    this.props.actions.downloadFirmware(name);
  }
  renderTableHeaders() {
    return (
      <TableHead>
        <TR>
          <TH>
            <FormattedMessage id="devices.tableHeader.type" defaultMessage="Type" />
          </TH>
          <TH>
            <FormattedMessage id="devices.tableHeader.name" defaultMessage="Name" />
          </TH>
          <TH align="right">
            <FormattedMessage id="devices.tableHeader.sharingData" defaultMessage="Sharing data" />
          </TH>
          <TH align="right">
            <FormattedMessage id="devices.tableHeader.puk" defaultMessage="Puk" />
          </TH>
          <TH align="right">
            <FormattedMessage id="devices.tableHeader.serial" defaultMessage="Serial number" />
          </TH>
          <TH align="right">
            <FormattedMessage id="devices.tableHeader.firmware" defaultMessage="Firmware" />
          </TH>
          <TH></TH>
        </TR>
      </TableHead>
    );
  }

  renderTableBody() {
    return <TableBody>{this.renderDeviceRows()}</TableBody>;
  }

  instrumentNameChanged(evt) {
    this.setState({
      instrumentName: evt.target.value,
    });
  }
  saveInstrumentName() {
    const id = this.state.selectedInstrument && this.state.selectedInstrument.id;
    const name = this.state.instrumentName;
    this.props.actions.setInstrumentName(id, name);
  }
  selectIntrument(inst) {
    this.setState({
      selectedInstrument: inst,
      selectedInstrumentType: inst && inst.instrumentModel,
      instrumentName: inst ? inst.name : '',
    });
  }
  openInstrumentNameModal(inst) {
    this.selectIntrument(inst);
    this.setState({
      showInstrumentNameModal: true,
    });
  }
  closeInstrumentModal() {
    this.selectIntrument(null);
    this.setState({
      showInstrumentNameModal: false,
    });
  }
  render() {
    //Cannot act as if not SuperAdmin or AdminLv1
    if (
      this.props.user.role !== 'SuperAdmin' &&
      this.props.user.role !== 'AdminLv1' &&
      this.props.user.role !== 'AdminLv2' &&
      this.actAsOther
    ) {
      return null;
    }

    // const demo = this.props.user.role === 'Demo' ? true : false;

    // const actions = [
    //   {
    //     action: this.downloadFirmware.bind(this, 'latestgatewaypc'),
    //     actionText: 'Windows 10',
    //   },
    //   {
    //     action: this.downloadFirmware.bind(this, 'latestgatewaymac'),
    //     actionText: 'macOS',
    //   },
    // ];
    // const headerButtonsRight = [
    //   {
    //     label: this.intl.formatMessage({ id: 'devices.addNew', defaultMessage: 'Add new' }),
    //     icon: 'add',
    //     action: this.showRegisterInstrumentModal,
    //   },
    // ];
    return (
      <div>
        {this.renderDeviceRowsOnMobile()}
        <div className={styles.deviceTable}>
          <Table>
            {this.renderTableHeaders()}
            {this.renderTableBody()}
          </Table>
        </div>

        <H2 className={styles.dowloadHeader}>
          <FormattedMessage id="devices.downloads" defaultMessage="Downloads" />
        </H2>

        <div className={styles.downloadSections}>
          <div className={styles.downloadSection}>
            <H3>
              <FormattedMessage id="devices.beaconGateway" defaultMessage="Beacon Gateway" />
            </H3>
            <div className={cn(styles.buttonWrapper)}>
              <LargeButton
                label={this.intl.formatMessage({
                  id: 'devices.downloadForWindows',
                  defaultMessage: 'Download for Windows',
                })}
                loading={this.state.downLoadingFirmwareType === 'latestgatewaypc'}
                onClick={this.downloadFirmware.bind(this, 'latestgatewaypc')}
              >
                {windowsIcon}
              </LargeButton>
              <LargeButton
                label={this.intl.formatMessage({
                  id: 'devices.downloadForMac',
                  defaultMessage: 'Download for Mac',
                })}
                loading={this.state.downLoadingFirmwareType === 'latestgatewaymac'}
                onClick={this.downloadFirmware.bind(this, 'latestgatewaymac')}
              >
                {macIcon}
              </LargeButton>
            </div>
            <div className={styles.downloadDescription}>
              <H4>
                <FormattedMessage
                  id="devices.downloadInstructions"
                  defaultMessage="Download instructions"
                />
              </H4>
              <FormattedMessage
                id="devices.download11"
                defaultMessage="1. Download the Gateway software for your Beacon/Mega ISQ II (click button above)"
              />
              <br />
              <FormattedMessage
                id="devices.download12"
                defaultMessage="2. Wait for the download to complete (could take a while depending on your connection)"
              />
              <br />
              <FormattedMessage
                id="devices.download13"
                defaultMessage="3. Run the downloaded installation file"
              />
            </div>
          </div>

          <div className={styles.downloadSection}>
            <H3>
              <FormattedMessage id="devices.idxFirmware" defaultMessage="IDx firmware" />
            </H3>
            <div className={cn(styles.buttonWrapper)}>
              <LargeButton
                label={this.intl.formatMessage({
                  id: 'devices.downloadFirmware',
                  defaultMessage: 'Download firmware',
                })}
                loading={this.state.downLoadingFirmwareType === 'latestfirmware'}
                onClick={this.downloadFirmware.bind(this, 'latestfirmware')}
              >
                {IDxIcon}
              </LargeButton>
            </div>
            <div className={styles.downloadDescription}>
              <H4>
                <FormattedMessage
                  id="devices.downloadInstructions"
                  defaultMessage="Download instructions"
                />
              </H4>
              <FormattedMessage
                id="devices.download21"
                defaultMessage="1. Download latest firmware for your IDx (click button above)"
              />
              <br />
              <FormattedMessage
                id="devices.download22"
                defaultMessage="2. Wait for the download to complete (could take a while depending on your connection)"
              />
              <br />
              <FormattedMessage
                id="devices.download23"
                defaultMessage="3. Copy the .m2f binary file to a USB memory stick"
              />
              <br />
              <FormattedMessage
                id="devices.download24"
                defaultMessage="4. Insert the memory stick in your IDx while it is running"
              />
              <br />
              <FormattedMessage
                id="devices.download25"
                defaultMessage="5. Follow instructions on the IDx display"
              />
              <br />
              <div className={styles.noteContainer}>
                <FormattedMessage
                  id="devices.downloadNote"
                  defaultMessage="Note: you cannot open or view the .m2f file"
                />
                <br />
              </div>
            </div>
          </div>
        </div>

        {this.props.getInstruments.busy ? (
          <Spinner className={styles.spinnerBackground} />
        ) : (
          <Section>
            <SectionInner>
              {/* <PanelWrapper>{this.renderInstruments()}</PanelWrapper> */}
            </SectionInner>
          </Section>
        )}
        <Modal
          fullModal={true}
          header={this.intl.formatMessage({
            id: 'devices.changeInstrumentName',
            defaultMessage: 'Change Instrument Name',
          })}
          onDismiss={() => this.closeInstrumentModal()}
          show={this.state.showInstrumentNameModal}
          modalContentClass={styles.modalContent}
        >
          <ChangeDeviceName
            instrumentNameChanged={this.instrumentNameChanged}
            instrumentName={this.state.instrumentName}
            selectedInstrumentType={this.state.selectedInstrumentType}
          />
          <div className={styles.modalButtonWrapper}>
            <Button
              big
              value={this.intl.formatMessage({ id: 'general.cancel', defaultMessage: 'Cancel' })}
              onClick={() => this.closeInstrumentModal()}
            />
            <Button
              primary
              big
              value={this.intl.formatMessage({ id: 'general.save', defaultMessage: 'Save' })}
              onClick={() => this.saveInstrumentName()}
              disabled={!this.state.instrumentName}
              loading={this.props.setInstrumentName.busy}
              rightIcon={'done'}
            />
          </div>
        </Modal>
      </div>
    );
  }
}

function mapState(state) {
  return {
    locale: state.translation.locale,
    user: state.user.user,
    getInstruments: state.instrument.getInstruments,
    instruments: state.instrument.instruments,
    registerInstrument: state.instrument.registerInstrument,
    setInstrumentName: state.instrument.setInstrumentName,
    shareInstrumentPatients: state.instrument.shareInstrumentPatients,
    downloadFirmware: state.firmware.downloadFirmware,
  };
}

function mapDispatch(dispatch) {
  return {
    actions: bindActionCreators(
      { ...instrumentActions, ...firmwareActions, ...accountActions, ...generalActions },
      dispatch
    ),
  };
}

export default connect(mapState, mapDispatch)(injectIntl(Devices));
